export default "__VITE_ASSET__Dv9Ki1Cb__"